/** Small inline icons used by kit components (Lucide paths, MIT). */
const Svg = ({ d, size = 16 }: { d: string; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={d} />
  </svg>
);
export const ChevronDown = () => <Svg d="m6 9 6 6 6-6" />;
export const ChevronLeft = () => <Svg d="m15 18-6-6 6-6" />;
export const ChevronRight = () => <Svg d="m9 18 6-6-6-6" />;
export const Check = ({ size = 16 }: { size?: number }) => <Svg d="M20 6 9 17l-5-5" size={size} />;
export const X = () => <Svg d="M18 6 6 18M6 6l12 12" size={14} />;
export const Calendar = () => <Svg d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />;
export const Spark = () => <Svg size={22} d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" />;
export const Trash = () => <Svg size={22} d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />;
export const Alert = () => <Svg size={22} d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0zM12 9v4M12 17h.01" />;
export const Info = () => <Svg size={22} d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 16v-4M12 8h.01" />;
